import type { PumpStatus } from "@tandemdiabetes/sugarmate-api-react-client"
import { PumpBasalRateState } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  BasalRateDisconnectedIcon,
  BasalRateRaisedIcon,
  BasalRateReducedIcon,
  BasalRateStandardIcon,
  BasalRateStoppedIcon,
  BasalRateSuspendedIcon,
  BasalRateTempIcon,
  BasalRateTempZeroIcon,
  BasalRateZeroIcon,
} from "@tandemdiabetes/sugarmate-react-components"

import type {
  ComponentPropsWithoutRef,
  FC,
  Ref,
  SVGProps,
} from "react"
import {
  forwardRef,
  useMemo,
} from "react"

import { DataRecency } from "src/types"

export interface Props extends ComponentPropsWithoutRef<"svg"> {
  pumpStatus: PumpStatus;
  pumpStatusRecency: DataRecency;
}

export const PumpBasalRateIcon = forwardRef<SVGElement, Props>(
  function PumpBasalRateIcon(props: Props, propRef: Ref<SVGElement>) {
    const {
      pumpStatus,
      pumpStatusRecency,
      ...svgProps
    } = props

    const { basal_rate_state: basalRateState } = pumpStatus

    const Icon: FC<SVGProps<SVGElement>> = useMemo(
      () => {
        if (pumpStatusRecency === DataRecency.Stale) {
          return BasalRateDisconnectedIcon
        }

        switch (basalRateState) {
          case PumpBasalRateState.Standard:
            return BasalRateStandardIcon
          case PumpBasalRateState.SuspendedBasalIQ:
            return BasalRateSuspendedIcon
          case PumpBasalRateState.Reduced:
            return BasalRateReducedIcon
          case PumpBasalRateState.Raised:
            return BasalRateRaisedIcon
          case PumpBasalRateState.Temp:
            return BasalRateTempIcon
          case PumpBasalRateState.TempZero:
            return BasalRateTempZeroIcon
          case PumpBasalRateState.SuspendedControlIQ:
          case PumpBasalRateState.Zero:
            return BasalRateZeroIcon
          case PumpBasalRateState.AllDeliveriesStopped:
            return BasalRateStoppedIcon
          case PumpBasalRateState.NoData:
          default:
            return BasalRateDisconnectedIcon
        }
      },
      [
        basalRateState,
        pumpStatusRecency,
      ],
    )

    return (
      <Icon
        {...svgProps}
        ref={propRef}
      />
    )
  },
)
